import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import GuestNaviBar from './Navigator/GuestNaviBar';
import styles from './Guest.module.scss';

// 본문 문구는 src/locales/{ko,en}.json 의 overview 아래에 있습니다.
// <br/> 과 <strong> 이 섞여 있어 t() 대신 Trans 로 그립니다. 두 태그는
// i18n 설정의 transKeepBasicHtmlNodesFor 에 등록되어 있어 components 를
// 따로 넘기지 않아도 실제 요소로 렌더됩니다.
const Introduce = () => {
  const { t } = useTranslation();

  // 소개 항목이 늘어도 JSX 를 복사하지 않도록 키만 나열합니다.
  const sections = ['sos', 'sar', 'workbook', 'roadmap'];

  return (
    <>
      <GuestNaviBar />
      <div className={styles['contact-container']}>
        <h1 className={styles['contact-title']}>{t('overview.title')}</h1>
        <div className={styles['guide-container']}>
          <div className={styles['guide-content']}>
            <p className={styles['intro-text']}>
              <Trans i18nKey="overview.tagline" />
            </p>

            <p className={styles['intro-text']}>
              <Trans i18nKey="overview.intro" />
            </p>

            {sections.map((key, index) => (
              <div className={styles['feature-section']} key={key}>
                {/* 첫 항목만 별도 클래스를 씁니다. 기존 마크업을 유지합니다. */}
                <h2 className={index === 0 ? styles.featureTitle : undefined}>
                  {t(`overview.${key}.title`)}
                </h2>
                <p>
                  <Trans i18nKey={`overview.${key}.body`} />
                </p>
              </div>
            ))}

            <div className={styles['conclusion']}>
              <p>
                <Trans i18nKey="overview.conclusion" />
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Introduce;
